import React, { type ReactNode } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface TooltipOverlayProps {
  title: string;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
  children: ReactNode;
  className?: string;
}

const TooltipOverlay: React.FC<TooltipOverlayProps> = ({
  title,
  placement = 'auto',
  children,
  className = '',
}) => {
  if (!title) return <>{children}</>;

  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip>{title}</Tooltip>}>
      {/* d-inline-flex + align-items-center centers the wrapped icon/content within this
          span's own box, instead of default inline-block baseline alignment (which sits
          an SVG's bottom edge on the text baseline, reading as "too low"). Previously
          plain d-inline-block - some call sites tried to override it locally with their
          own d-inline-flex className, which only worked when Bootstrap's compiled CSS
          happened to order that utility after this one.
          align-middle is the other half: it controls how this whole span (now an
          inline-flex box) sits within the *surrounding* text's line - without it, a small
          icon still lands low next to a tall/bold heading, since an inline-flex box's own
          vertical-align still defaults to baseline. */}
      <span
        className={`d-inline-flex align-items-center align-middle tooltip-overlay-trigger cursor-pointer ${className}`}
      >
        {children}
      </span>
    </OverlayTrigger>
  );
};

export default TooltipOverlay;
